import { Directive, ElementRef } from '@angular/core';

@Directive({ selector: '[autocompleteOff]' })
export class AutocompleteOffDirective {
	constructor(private _el: ElementRef<HTMLElement>) {
		this._el.nativeElement.setAttribute('autocomplete', 'off');
	}
}
